import { z } from 'zod';

export const moveCropResponseSchema = z.object({
  newLocalPath: z.string(),
  newVerticalLocalPath: z.string().nullable().optional(),
});

export type IMoveCropResponse = z.infer<typeof moveCropResponseSchema>;
